import axios from 'axios';
import type { ClientLookupRequestDto } from '@@@/dto/api/clients/ClientLookupRequestDto';
import type { ClientLookupResponseDto } from '@@@/dto/api/clients/ClientLookupResponseDto';
import { CheckDomainAvailabilityResponseDto } from '@@@/dto/api/domains/CheckDomainAvailabilityResponseDto';
import { DomainCheckAvailabilityDto } from '@/features/domain-checker-input/dtos/DomainCheckAvailabilityDto';

const API_BASE = import.meta.env.VITE_API_BASE_URL as string;

export default class WhmcsApiService {
    static async lookupClient(payload: ClientLookupRequestDto): Promise<ClientLookupResponseDto> {
        const url = `${API_BASE}/clients/lookup`;
        const response = await axios.post<ClientLookupResponseDto>(url, payload);
        return response.data;
    }

    static async checkDomainAvailability(domain: string): Promise<DomainCheckAvailabilityDto> {
        const url = `${API_BASE}/domains/check?domain=${encodeURIComponent(domain)}`;
        const response = await axios.get<CheckDomainAvailabilityResponseDto>(url);

        // Transform the API response into the expected frontend DTO
        const apiData = response.data;

        // Parse whois data to determine if user owns domain and if transfer is recommended
        let userOwns: boolean | null = null;
        let transferRecommended: boolean | null = null;

        if (!apiData.available) {
            // For unavailable domains, we don't know ownership yet - let the UI ask
            userOwns = null; // Unknown ownership - UI will ask user
            transferRecommended = true; // Recommend transfer for unavailable domains
        }

        return {
            domainName: domain,
            available: apiData.available,
            userOwns,
            transferRecommended
        };
    }
}
